import { createApiSlice } from "@common";
import { CRUD_BUSINESS_NEED_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addBusinessNeedStatus",
    method: "post",
    url: CRUD_BUSINESS_NEED_STATUS,
    stateKey: "message",
  },
  {
    name: "getBusinessNeedStatus",
    method: "get",
    url: CRUD_BUSINESS_NEED_STATUS,
    stateKey: "data",
  },
  {
    name: "updateBusinessNeedStatus",
    method: "put",
    url: CRUD_BUSINESS_NEED_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteBusinessNeedStatus",
    method: "delete",
    url: CRUD_BUSINESS_NEED_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"businessNeedStatus",
 apiConfig, 
 customReducers);
const businessNeedStatusSlice = slice;

export default businessNeedStatusSlice.reducer;

export const {
  addBusinessNeedStatus,
  getBusinessNeedStatus,
  updateBusinessNeedStatus,
  deleteBusinessNeedStatus,
} = thunks;

export const { rowSelect } = actions;
